<div
  *ngIf="followupQuestions.length > 0"
  class="followup-questions-footer"
  [class.collapsed]="!isExpanded"
  [class.expanded]="isExpanded">
  <!-- Collapsed State -->
  <button
    *ngIf="!isExpanded"
    (click)="toggleExpanded()"
    class="questions-toggle tw-w-full tw-h-full tw-flex tw-items-center tw-gap-2 tw-px-3 tw-text-sm tw-text-gray-300 hover:tw-bg-gray-800 tw-transition-colors tw-border-0 tw-bg-transparent tw-cursor-pointer">
    <mat-icon class="tw-text-blue-400 tw-text-base">psychology</mat-icon>
    <span class="tw-flex-1 tw-text-left"
      >{{ followupQuestions.length }} suggested follow-up
      {{ followupQuestions.length === 1 ? 'question' : 'questions' }}</span
    >
    <mat-icon class="tw-text-lg tw-w-8 tw-h-8">expand_less</mat-icon>
  </button>

  <!-- Expanded State -->
  <div *ngIf="isExpanded" class="expanded-content tw-flex tw-flex-col">
    <!-- Header with collapse button -->
    <div
      class="footer-header tw-flex tw-items-center tw-justify-between tw-px-3 tw-py-2 tw-border-b tw-border-gray-700">
      <div
        class="header-left tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-white">
        <mat-icon class="tw-text-blue-400 tw-text-base">psychology</mat-icon>
        <span>Suggested Followup Questions</span>
      </div>
      <button mat-icon-button (click)="collapse()" class="tw-p-0 tw-w-8 tw-h-8">
        <mat-icon class="tw-text-lg tw-w-8 tw-h-8">expand_more</mat-icon>
      </button>
    </div>

    <!-- Scrollable questions list -->
    <div class="questions-list tw-overflow-y-auto tw-px-2 tw-py-2 tw-space-y-2">
      <div
        class="question-item tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-3 tw-py-2 tw-rounded tw-bg-gray-800 hover:tw-bg-gray-750 tw-transition-colors tw-cursor-pointer"
        *ngFor="let question of followupQuestions"
        (click)="onQuestionClick(question)">
        <div class="item-content tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-flex-1">
          <mat-icon class="tw-text-blue-400 tw-text-base tw-flex-shrink-0">arrow_forward</mat-icon>
          <span class="item-text tw-text-sm tw-text-white">{{ question }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
